import Base from './Base'

/**
 * http://yapi.tmeoa.com/project/5240/interface/api/cat_12479
 */
class ComplaintService extends Base {
  find(query) {
    return this.post('/complaint/query_complaint_list', query, { noEmpty: true })
  }

  findById(id) {
    return this.post('/complaint/query_complaint_detail_by_id', { id })
  }

  save(postData) {
    return this.post('/complaint/save_complaint_detail', postData)
  }

  findSongList(query) {
    return this.post('/complaint/query_complaint_track_list', query, { noEmpty: true })
  }

  saveSongList(postData) {
    postData.mode = 2
    return this.post('/complaint/batch_save_track_list_or_match_track', postData)
  }

  findMatchList(query) {
    return this.post('/complaint/query_track_match_list', query, { noEmpty: true })
  }

  saveMatchList(postData) {
    postData.mode = 3
    return this.post('/complaint/batch_save_track_list_or_match_track', postData)
  }

  editTrackList(postData) {
    return this.post('/complaint/save_tracklist', postData)
  }

  editMatch(postData) {
    return this.post('/complaint/save_match_track', postData)
  }

  deleteTrackList(postData) {
    return this.post('/complaint/del_tracklist', postData)
  }

  deleteMatch(postData) {
    return this.post('/complaint/del_match_track', postData)
  }

  /**
   * 批量上传
   * @param {*} postData
   * params1 url // cos 地址
   * params2 mode // 上传模块：0. 申诉单 1. 歌单 2. 匹配结果
   * params3 complianType // 申诉类型：0. 侵权投诉 1. 白名单 2. 下架 3. 版权认领
   * params4 id // 流水ID
   * params5 rightFileList // mode === 1 时，授权文件列表
   * @returns
   */
  batchUpload(postData) {
    return this.post('/complaint/batch_upload_complaint_track_list', postData)
  }

  exportSongListAll(query) {
    return this.post('/complaint/batch_download_tracklist', query)
  }

  exportMatchListAll(query) {
    return this.post('/complaint/batch_download_match_result', query)
  }

  /**
   * 打印预览
   */
  getPromisePreview(postData) {
    return this.post('/complaint/get_promise_takedown_preview', postData)
  }

  /**
   * 匹配导出记录查询
   */
  queryMatchDownloadRecords(query) {
    return this.post('/complaint/query_task_match_result', query, { noEmpty: true })
  }

  /**
   * 外部查询
   */
  queryOtherComplaintTrackList(query) {
    return this.post('/complaint/query_other_complaint_track_list', query, { noEmpty: true })
  }

  /**
   * 外部人员提单保存接口
   */
  saveOtherComplaintDetail(postData) {
    return this.post('/complaint/save_other_complaint_detail', postData)
  }

  /**
   * 外部修改歌单
   */
  saveOtherComplaintTrack(postData) {
    return this.post('/complaint/save_other_complaint_detail_by_id', postData)
  }

  queryComplaintListForUser(query) {
    return this.post('/complaint/query_complaint_list_for_user', query, { noEmpty: true })
  }

  querySubComplaintForUser(query) {
    return this.post('/complaint/query_sub_complaint_for_user', query, { noEmpty: true })
  }

  /**
   * 解析歌单上传的excel文件并返回解析结果
   * params1 url // cos 地址
   * params2 complianType // 申诉类型：0. 侵权投诉 1. 白名单 2. 下架 3. 版权认领
   * params3 rightFileList
   * @returns
   */
  parseCommitExcel(postData) {
    return this.post('/complaint/parse_commit_excel', postData)
  }

  queryHistory(query) {
    return this.post('/complaint/query_history', query, { noEmpty: true })
  }

  queryDetailSubComplaint(query) {
    return this.post('/complaint/query_detail_sub_complaint', query, { noEmpty: true })
  }

  saveConfirm(postData) {
    return this.post('/complaint/save_confirm', { list: postData })
  }

  /**
   * 获取解析歌曲链接的结果
   * @param {*} postData
   * @returns
   */
  getAnalysisLinkMsg(postData) {
    return this.post('/complaint/get_analysis_link_msg', postData)
  }
}

export default new ComplaintService()
